import React, { useEffect, useState } from 'react';
import instance from '../../service/axiosInstane';
import { useDispatch, useSelector } from 'react-redux';
import { StateProps } from '../../redux/reducer';
import { updateDownloadID } from '../../redux/action';
import { errorMessage } from '../../config/errorsMsg';
import { flashBarTheme } from '../../config/flashBar';
import FlashBar from '../FlashBar/FlashBar';

const Download = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState<number>(0);
  const [status, setStatus] = useState('Download');
  const downloadProps = useSelector((state: StateProps) => state.downloadProps);
  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });

  useEffect(() => {
    getFileDetails();
  }, [downloadProps]);

  const getFileDetails = async () => {
    if (downloadProps.downloadGuid) {
      await instance
        .get(`/documents/${downloadProps.downloadGuid}`)
        .then((response) => {
          if (response.status === 200) {
            downloadFile(downloadProps.downloadGuid, response.data.name);
          }
        })
        .catch((e) => {
          setFlashbar({
            ...flashbar,
            isOpen: true,
            message: errorMessage.oops,
            type: flashBarTheme.ERROR,
          });
        });
    }
  };

  let statusPercentage = 0;
  const downloadFile = async (guid: string, fileName: string) => {
    setStatus('Downloading...');
    try {
      const response = await instance.get(`/documents/${guid}/download`, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const percentage = Math.round(
            (Number(progressEvent.loaded) / Number(progressEvent.total)) * 100
          );
          setProgress(percentage);
          statusPercentage = percentage;
        }, // Important to handle binary data
      });

      // Create a blob and a link to trigger the download
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');

      link.href = url;
      link.download = fileName; // Set the desired file name

      document.body?.appendChild(link);
      link.click();

      // Clean up and remove the link after the download
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      if (statusPercentage === 100) {
        setStatus('Download Complete');
        setTimeout(() => {
          const obj = {
            isShow: false,
            downloadGuid: '',
          };
          dispatch(updateDownloadID(obj));
          setStatus('Download');
        }, 2000);
      }
    } catch (error) {
      const obj = {
        isShow: false,
        downloadGuid: '',
      };
      dispatch(updateDownloadID(obj));
      setFlashbar({
        ...flashbar,
        isOpen: true,
        message: errorMessage.oops,
        type: flashBarTheme.ERROR,
      });
    }
  };

  const closePopUp = () => {
    const obj = {
      isShow: false,
      downloadGuid: '',
    };
    dispatch(updateDownloadID(obj));
    setStatus('Download');
  };

  return (
    <div className={` fixed bottom-0 right-0 z-[1500] mb-2 mr-6 shadow-md `}>
      {downloadProps.isShow && (
        <div className="bg-white shadow-md border w-64 h-fit p-4 text-white rounded-md">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div>
                <i className="fa-solid fa-download text-[#45a6c4] text-[20px]"></i>
              </div>
              <div>
                <div className={`text-[blue] text-sm`}>{status}</div>
              </div>
            </div>
            <div className="cursor-pointer" onClick={() => closePopUp()}>
              <i className="fa-solid fa-xmark text-black "></i>
            </div>
          </div>
          <div className="border text-[10px] w-[200px] rounded-sm mt-1 font-semibold border-[#41b2f3]  ">
            <div
              className={`w-[${
                progress * 2
              }px] rounded-sm flex justify-end bg-[#41b2f3] border border-white`}
            >
              <div>{progress}%</div>
            </div>
          </div>
        </div>
      )}
      <FlashBar
        message={flashbar.message}
        isOpen={flashbar.isOpen}
        type={flashbar.type}
        handleClose={() => {
          setFlashbar({ ...flashbar, isOpen: false });
        }}
      />
    </div>
  );
};

export default Download;
